import { APIRoute } from '@/modules/utils'
import { HydraCollection, HydraSearchParams, IRI } from 'emt-library'
import { ConversationSummary } from '@/dataV3/Conversation/ConversationSummary'

export const Route: APIRoute = {
  method: 'GET',
  path: '/v2/community/conversations',
}

export const NextPageRoute = (nextPage: string): APIRoute => ({
  method: 'GET',
  path: nextPage,
})

export type SearchParams = HydraSearchParams

export type Response = HydraCollection<ConversationSummary> & {
  '@topic': IRI
}
